import { BookType, ColInfo, utils, write } from 'xlsx'

interface XlsxGenerator {
  data: any[]
  sheetName?: string
  headers?: string[]
  bookType?: BookType
}

export const generateXlsxFromJson = ({ data, sheetName, headers, bookType = 'xlsx' }: XlsxGenerator) => {
  const workbook = utils.book_new()
  const worksheet = utils.json_to_sheet(data, { cellStyles: true })

  if (headers) {
    utils.sheet_add_aoa(worksheet, [headers], { origin: 'A1' })
  }

  const [firstRow] = data
  const columnSizes = generateColumnSizes(firstRow)
  worksheet['!cols'] = columnSizes

  utils.book_append_sheet(workbook, worksheet, sheetName || 'Data')

  return write(workbook, { bookType, type: 'buffer' })
}

const generateColumnSizes = (row): ColInfo[] => {
  const minCharactersLength = 12

  return Object.keys(row).map((columnName) => {
    const propertyLength = String(columnName).length
    const valueLength = row[columnName] ? String(row[columnName]).length : minCharactersLength

    return { wch: Math.max(propertyLength, valueLength, minCharactersLength) }
  })
}
